<template>
    <div class="landing-footer">
        <div class="landing-container wrap">
            <div class="section">
                <div class="list">
                    <div class="item">
                        <div class="title">
                            飛豬
                        </div>
                        <div class="sub-item">
                            <router-link :to="{ name: 'aboutUs'}">關於我們</router-link>
                        </div>
                        <div class="sub-item socail">
                            <a href="https://www.facebook.com/%E9%A3%9B%E8%B1%AC%E7%AE%A1%E5%AE%B6-109776907595266" target="_blank" rel="noopener noreferrer">
                                <img src="@/assets/img/landingPage/home/fb.png" alt="">
                            </a>
                            <a href="https://line.me/R/ti/p/%40599ncjgk" target="_blank" rel="noopener noreferrer">
                                <img src="@/assets/img/landingPage/home/line.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="item">
                        <div class="title">
                            幫助
                        </div>
                        <!-- <div class="sub-item">
                            常見問題
                        </div> -->
                        <div class="sub-item">
                            <router-link :to="{ name: 'contact'}">洽談合作</router-link>
                        </div>
                        <div class="sub-item">
                            <a href="https://line.me/R/ti/p/%40599ncjgk" target="_blank" rel="noopener noreferrer">
                            聯絡我們
                            </a>
                        </div>
                    </div>
                </div>
                <div class="qrcode-wrap">
                    <div class="qrcode">
                        <div class="title">
                            個人房東APP
                        </div>
                        <vue-qrious :value="hostUrlLandlord"  :size="size" level="L"/>
                        <div class="name" style="color:#fb9479">
                            飛豬管家
                        </div>
                    </div>
                    <div class="qrcode" v-if="$route.name !== 'landlordLogin'">
                        <div class="title">
                            房客APP
                        </div>
                        <vue-qrious :value="hostUrlTenant"  :size="size" level="L"/>
                        <div class="name" style="color:#2479fa">
                            飛豬找房
                        </div>
                    </div>
                </div>
                <div class="qrcode-wrap-mb">
                    <div class="qrcode">
                        <div class="info">
                            <div class="title">
                                個人房東APP
                            </div>
                            <img src="@/assets/img/landingPage/bussiness/landlord.svg" alt="">
                            <div class="name" style="color:#fb9479">
                                飛豬管家
                            </div>
                        </div>
                        <div class="download-app">
                            <a :href="iosUrl.landlord">
                                <img src="@/assets/img/landingPage/bussiness/apple_store.png" alt="">
                            </a>
                            <a :href="androidUrl.landlord">
                                <img src="@/assets/img/landingPage/bussiness/google_store.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="qrcode" v-if="$route.name !== 'landlordLogin'">
                        <div class="info">
                            <div class="title">
                                房客APP
                            </div>
                            <img src="@/assets/img/landingPage/bussiness/tenant.svg" alt="">
                            <div class="name" style="color:#2479fa">
                                飛豬找房
                            </div>
                        </div>
                        <div class="download-app">
                            <a :href="iosUrl.tenant">
                                <img src="@/assets/img/landingPage/bussiness/apple_store.png" alt="">
                            </a>
                            <a :href="androidUrl.tenant">
                                <img src="@/assets/img/landingPage/bussiness/google_store.png" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <span class="company">
                    © {{year}} 方居浩斯科技股份有限公司版權所有
                </span>
                <div class="private">
                    <router-link :to="{ name: 'privacyPolicy'}">隱私權政策</router-link>
                </div>
                <div>
                    <router-link :to="{ name: 'userTerms'}">會員條款</router-link>
                </div>
            </div>
            <div class="right-mb">
                <div class="private-wrap">
                    <div class="private">
                        <router-link :to="{ name: 'privacyPolicy'}">隱私權政策</router-link>
                    </div>
                    <div>
                        <router-link :to="{ name: 'userTerms'}">會員條款</router-link>
                    </div>
                </div>
                <span class="company">
                    © {{year}} 方居浩斯科技股份有限公司版權所有
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import VueQrious from 'vue-qrious'
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            size: 88,
            hostUrlTenant: window.location.href + '?device=1&type=tenant',
            hostUrlLandlord: window.location.href + '?device=1&type=landlord',
        }
    },
    computed: {
        year: function () {
            let d = new Date();
            let year = d.getFullYear();

            return year
        },
        ...mapGetters({
            system: 'GET_DEVICE_SYSTEM',
            iosUrl: 'GET_IOS_URL',
            androidUrl: 'GET_ANDROID_URL',
        })
    },
    components: {
        VueQrious
    }
}
</script>
<style lang="scss" scoped>
    .landing-footer{
        display: flex;
        justify-content: center;
        .wrap{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 56px 0 42px;
            .section{
                position: relative;
                display: flex;
                align-items: center;
                margin-bottom: 40px;
                .list{
                    display: flex;
                    margin-right: 39px;
                    .item{
                        color: #474342;
                        margin-right: 93px;
                        .title{
                            font-weight: bold;
                            margin-bottom: 16px;
                        }
                        .sub-item{
                            font-size: 16px;
                            margin-bottom: 21px;
                            &.socail{
                                a >img{
                                    width: 32px;
                                    margin-right: 12px;
                                }
                            }
                        }
                    }
                }
                .qrcode-wrap{
                    display: flex;
                    align-items: center;
                    .qrcode{
                        text-align: center;
                        margin-right: 88px;
                        .title{
                            color: #474342;
                            margin-bottom: 10px;
                        }
                        img{
                            border-radius: 4px;
                        }
                        .name{
                            margin-top: 10px;
                            font-weight: 400;
                        }
                    }
                }
                .qrcode-wrap-mb{
                    display: none;
                }
            }
            .right{
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #878787;
                a{
                    color: #878787;
                }
                .private{
                    position: relative;
                    margin: 0 23px;
                    &::before{
                        content: '';
                        width: 1px;
                        height: 11px;
                        background: #878787;
                        position: absolute;
                        left: -12px;
                        top: 2px;
                    }
                    &::after{
                        content: '';
                        width: 1px;
                        height: 11px;
                        background: #878787;
                        position: absolute;
                        right: -12px;
                        top: 2px;
                    }
                }

            }
            .right-mb{
                display: none;
            }
        }
    }
    @media screen and (max-width: 1100px) {
        .landing-footer{
            .wrap{
                width: 100%;
            }
        }
    }
    @media screen and (max-width: 860px) {
        .landing-footer{
            .wrap{
                flex-direction: column;
                padding: 80px 15px 42px;
                .section{
                    flex-direction: column;
                    width: 100%;
                    .list{
                        width: 375px;
                        align-items: flex-start;
                        justify-content: space-between;
                        padding: 0 53px;
                        box-sizing: border-box;
                        margin-right: unset;
                        .item{
                            margin-right: unset;
                            .title{
                                margin-bottom: 16px;
                            }
                        }
                    }
                    .qrcode-wrap{
                        display: none;
                    }
                    .qrcode-wrap-mb{
                        margin-top: 70px;
                        display: block;
                        .qrcode{
                            display: flex;
                            align-items: center;
                            margin-bottom: 30px;
                            .info{
                                width: 83px;
                                margin-right: 41px;
                                .title{
                                    color: #474342;
                                    margin-bottom: 12px;
                                }
                                .name{
                                    margin-top: 14px;
                                }
                            }
                            .download-app{
                                margin-top: 23px;
                                img{
                                    display: block;
                                    width: 144px;
                                    margin-bottom: 13px;
                                }
                            }
                        }
                    }
                }
                .right{
                    display: none;
                }
                .right-mb{
                    position: relative;
                    display: block;
                    font-size: 12px;
                    color: #878787;
                    bottom: 0px;
                    left: -16px;
                    .private-wrap{
                        display: flex;
                        align-items: center;
                        margin-bottom: 8px;
                        a{
                            color: #878787;
                        }
                        .private{
                            position: relative;
                            margin-right: 23px;
                            &::after{
                                content: '';
                                width: 1px;
                                height: 11px;
                                background: #878787;
                                position: absolute;
                                right: -12px;
                                top: 2px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/widges/footer.vue